/**
 * A broken business rule. `code` is stable: the API sends it to clients, and
 * clients translate it. `message` is for logs and developers, never shown raw.
 */
export class DomainError extends Error {
  readonly code: string
  readonly details: Readonly<Record<string, unknown>> | undefined

  constructor(code: string, message: string, details?: Record<string, unknown>) {
    super(message)
    this.name = 'DomainError'
    this.code = code
    this.details = details
  }
}
